import {app} from '../../app';
import {ISessionService} from "../../services/SessionService";

export class RadioGridQuestionPreviewComponent {

    protected sessionService:ISessionService;

    question:IQuestion;
    value:string[] = [];

    choices:string[] = [];
    rows:string[]    = [];
    style            = 'default';

    static $inject = ['SessionService'];

    constructor(sessionService:ISessionService) {
        this.sessionService = sessionService;
    }

    $onInit() {
        let style = this.question.meta.style;
        if (style) {
            this.style = style;
        }

        this.choices = this.question.meta.choices;
        this.rows    = this.question.meta.rows;
        for (let row of this.rows) {
            this.value.push("");
        }

        let defaultValues = this.question.meta.default;
        if (defaultValues && angular.isArray(defaultValues)) {
            for (let defaultValue of defaultValues) {
                if (defaultValue['choice'] && defaultValue['row']) {
                    let row         = defaultValue['row'];
                    this.value[row] = defaultValue['choice'];
                }
            }
        }

        let answer = this.sessionService.getAnswer(this.question.id);
        if (answer && answer.values.length > 0) {
            for (let value of answer.values) {
                let row         = value.row;
                this.value[row] = this.choices[value.choice];
            }
        }
    }
}

app.component('radioGridQuestionPreview', {
    templateUrl : 'templates/components/questionPreviews/radioGridQuestionPreview.html',
    controller  : RadioGridQuestionPreviewComponent,
    controllerAs: 'radioGridQuestionPreview',
    bindings    : {
        question: '<',
    }
});